import React from 'react';
import { Button } from '@lendi-ui/button';
import Spinner from '@lendi-ui/spinner';

import { BUTTON_STATUS } from '@funnels/constants';
import { useAnalytics } from '@funnels/providers';
import { run } from '@funnels/utils';

import { ButtonWrapper } from '../index.style';
import { SaveStatus } from './SaveStatus';

interface DesktopViewActionButtonsGroupProps {
  handleCancel?: () => void;
  handleSave?: () => void;
  isDisabled?: boolean;
  buttonStatus: BUTTON_STATUS;
  buttonStatusText: string;
  isLoading?: boolean;
}

const LABELS = {
  CANCEL: 'Cancel',
  SAVE: 'Save',
  TRY_AGAIN: 'Try Again',
};

function DesktopViewActionButtonsGroup(props: DesktopViewActionButtonsGroupProps) {
  const { tracking } = useAnalytics();
  const { isDisabled, handleCancel, buttonStatus, buttonStatusText, handleSave } = props;
  const primaryButtonText = buttonStatus !== BUTTON_STATUS.SAVING_UNSUCCESSFUL ? LABELS.SAVE : LABELS.TRY_AGAIN;

  return (
    <div>
      <ButtonWrapper>
        {handleCancel && (
          <Button
            data-component="desktop-secondary-button-action"
            variant="secondary"
            onClick={run(handleCancel, () => tracking?.button.secondary({ text: LABELS.CANCEL }))}
            size={'sm'}
          >
            {LABELS.CANCEL}
          </Button>
        )}
        <Button
          before={buttonStatus === BUTTON_STATUS.SAVING && <Spinner variant={'light'} />}
          variant="primary"
          data-component="desktop-button-action"
          onClick={run(handleSave, () => tracking?.button.primary({ text: primaryButtonText }))}
          size={'sm'}
          isDisabled={isDisabled}
        >
          {primaryButtonText}
        </Button>
      </ButtonWrapper>
      <SaveStatus buttonStatus={buttonStatus} buttonStatusText={buttonStatusText} handleCancel={handleCancel} />
    </div>
  );
}

export default DesktopViewActionButtonsGroup;
